/**
 * Telemedicine Intake Flow
 */

import './prelude'

import { CreditCard } from './intake/v2/credit-card'
import { InsuranceSelect } from './intake/v2/insurance-select'
import { InsuranceForm } from './intake/v2/insurance-form'
import { HealthHistoryRecentProviderVisitForm } from './intake/v2/health-history-recent-provider-visit-form'
import { HealthHistoryMedicationForm } from './intake/v2/health-history-medication-form'
import { HealthHistoryAllergyForm } from './intake/v2/health-history-allergy-form'
import { ContactForm } from './intake/v2/contact-form'
import { ProfileForm } from './intake/v2/profile-form'
import { PharmacyForm } from './intake/v2/pharmacy-form'
import { Tooltip } from './intake/v2/tooltip'
import { ProfileDetailForm } from './intake/v2/profile-detail-form'
import { selectAll as $ } from './intake/v2/dom'
import cardValidator from 'card-validator'
import Rails from "rails-ujs"

Rails.start()
/**
 * Prevent invalid forms from continuing
 */

$('[data-validate]').forEach(form => {
  form.addEventListener('submit', event => {
    if (form.checkValidity() === false || (form.querySelector('[data-cctype]') !== null && !creditCardValidation(form))) {
      event.preventDefault();
    } else {
      let submitBtn = form.querySelector('input[type="submit"]') || form.querySelector('button[type="submit"]')
      if (submitBtn) {
        submitBtn.setAttribute('disabled', 'disabled')
      }
      form.classList.remove('form-invalid')
    }
  })

  form.addEventListener(
    'invalid',
    event => {
      form.classList.add('form-invalid')
    },
    true
  )
  if (form.querySelector('[data-cctype]') !== null) {
    form.querySelector('[id*="expiration_month_mm"]').addEventListener('change', handleExpiryChange);
    form.querySelector('[id*="expiration_year_yyyy"]').addEventListener('change', handleExpiryChange);
  }
})

function creditCardValidation(form) {
  let valid = form.querySelector('[data-cardvalid]')
  let isCardNumValid, isCardExpiryValid = 0;
  isCardNumValid = parseInt(valid.getAttribute('data-cardvalid'))
  if (!isCardNumValid) {
    const label = document.querySelector('div[class="cc-number-error"]');
    label.querySelector('span').classList.remove('hidden');
  }
  //check expiry date validity
  let expiry_month = form.querySelector('[id*="expiration_month_mm"]').value;
  let expiry_year = form.querySelector('[id*="expiration_year_yyyy"]').value;
  let expiryValid = cardValidator.expirationDate(expiry_month + '/' + expiry_year)
  if (expiryValid && expiryValid.isPotentiallyValid && expiryValid.isValid) {
    isCardExpiryValid = 1
  }
  $('[data-ccexpiry]').forEach(el => {
    (isCardExpiryValid ? el.querySelector('select').classList.remove("invalid-card") : el.querySelector('select').classList.add("invalid-card"));
  })
  if (!isCardExpiryValid) {
    const label = document.querySelector('div[class="cc-expiration-error"]');
    label.querySelector('span').classList.remove('hidden');
  }
  return (isCardNumValid && isCardExpiryValid)
}

function handleExpiryChange(event) {
  const label = document.querySelector('div[class="cc-expiration-error"]');
  label.querySelector('span').classList.add('hidden');
  $('[data-ccexpiry]').forEach(el => {
    el.querySelector('select').classList.remove("invalid-card")
  })
  // Event listener for the month select change
  if (event.target.id.includes('expiration_month_mm')) {
    // Update year options based on the selected month
    generateYearOptions();
  }
};

// These use a query selector instead of a direct find by id, since it is used for both pat_com_topic_responses and the v2 intake flow
const expiryMonthSelect = document.querySelector('[id*="expiration_month_mm"]');
const expiryYearSelect = document.querySelector('[id*="expiration_year_yyyy"]');

// Function to generate valid year options
function generateYearOptions() {
  const currentYear = new Date().getFullYear();
  const selectedMonth = parseInt(expiryMonthSelect.value);
  const startYear = selectedMonth >= new Date().getMonth() + 1 ? currentYear : currentYear + 1;

  // Remove existing options
  expiryYearSelect.innerHTML = '';
  // Generate valid year options
  for (let year = startYear; year <= currentYear + 15; year++) {
    const option = document.createElement('option');
    option.value = year;
    option.textContent = year;
    expiryYearSelect.appendChild(option);
  }
}

// Initial year options generation in paymet form
const ccExpiryElement = document.querySelector('[data-ccexpiry]');
if (ccExpiryElement) {
  generateYearOptions();
}

$('[data-toggle]').forEach(toggle => {
  toggle.addEventListener('change', e => {
    let attribute = toggle.getAttribute('data-toggle')
    let target = $(attribute)

    // Toggle help text for hardware check
    if (attribute.indexOf('help') >= 0) {
      let helpText = document.querySelector(attribute)
      let didSelectNo = 'false' === e.target.value

      if (helpText.classList.contains('hidden') && didSelectNo) {
        helpText.classList.remove('hidden')
      } else {
        helpText.classList.add('hidden')
      }

      return
    }

    target.forEach(el => {
      el.parentElement.classList.toggle('hidden')
      el.disabled = !el.disabled
    })
  })

  if (toggle.getAttribute('data-toggle') == '#patient_relationship') {
    window.addEventListener("load", function () {
      if (toggle.checked) {
        document.querySelector('#patient_relationship_wrapper').classList.remove('hidden')
        document.querySelector('#patient_relationship').disabled = false
      }
    })
  }
})

$('[data-sc]').forEach(el => {
  toggleStoredCardFields(el.value)

  el.addEventListener('change', e => {
    let stored_card_id = e.target.value
    toggleStoredCardFields(stored_card_id)
  })
})

function toggleStoredCardFields(stored_card_id) {
  if (stored_card_id && parseInt(stored_card_id)) {
    $('[data-sc-optional]').forEach(el => {
      el.classList.add('hidden')
      let required_fields = el.querySelectorAll("[required]")
      required_fields.forEach(field => {
        field.removeAttribute('required')
      })
    })
  } else {
    $('[data-sc-optional]').forEach(el => {
      el.classList.remove('hidden')
      let required_fields = el.querySelectorAll("[oninvalid]")
      required_fields.forEach(field => {
        field.setAttribute('required', '')
      })
    })
  }
}

/**
 * Payment/Insurance Tooltips
 */

$('[data-tooltip]').forEach(el => {
  new Tooltip({ el })
})

/**
 * Insurance Form
 */

$('[data-module="insurance-form"]').forEach(el => {
  new InsuranceForm(el)
})

/**
 * Insurance Selection
 */

$('[data-insurance-select]').forEach(select => {
  new InsuranceSelect(select)
})

/**
 * Credit Card Detection
 */

$('[data-cctype]').forEach(el => {
  new CreditCard(el)
})

/**
 * On Demand Identities - Profile Detail Form
 */
$('[data-intake-identities-profile-detail-form]').forEach(el => {
  new ProfileDetailForm(el)
})

/**
 * Health History Recent Provider Visit Form
 */

$('[data-health-history-recent-provider-visit-form]').forEach(el => {
  new HealthHistoryRecentProviderVisitForm(el)
})

/**
 * Health History Medication Form
 */

$('[data-health-history-medication-form]').forEach(el => {
  new HealthHistoryMedicationForm(el)
})

/**
 * Health History Allergy Form
 */

$('[data-health-history-allergy-form]').forEach(el => {
  new HealthHistoryAllergyForm(el)
})

$('[data-pharmacy-form]').forEach(el => {
  new PharmacyForm(el)
})

$('[data-contact-form]').forEach(el => {
  new ContactForm(el)
})

$('[data-profile-form]').forEach(el => {
  new ProfileForm(el)
})
